export const COMMAND_QUALITY_LEVEL = "quality-level";
